import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_brands`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_brands/${id}`, options)
    .then(response => {
      let vehicle_brands = jsona.deserialize(response.data);
      delete vehicle_brands.links;
      return vehicle_brands;
    });
}

function add(vehicle_brands) {
  
  console.log(vehicle_brands);
  const payload = jsona.serialize({
    stuff: vehicle_brands,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_vehicle_brands`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(vehicle_brands) {
  const payload = jsona.serialize({
    stuff: vehicle_brands,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_vehicle_brands/${vehicle_brands.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_vehicle_brands/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_vehicle_brands/last/no`, options)
    .then(response => {
      return response.data;
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no
};

